import {Button, Grid, Heading} from '@primer/react-brand/esm'
import {useId} from 'react'

import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import Styles from './CtaBanner.module.css'

import type {Cta} from '../../../Index.types'

export interface CtaBannerProps {
  title: string
  cta: Cta
}

export const defaultProps: Partial<CtaBannerProps> = {}

export const CtaBanner = (props: CtaBannerProps) => {
  const initializedProps: CtaBannerProps = {...defaultProps, ...props}
  const {title, cta} = initializedProps
  const titleId = useId()

  return (
    <section className={Styles.CtaBanner} aria-labelledby={titleId}>
      <div className={Styles.CtaBanner__gridContent}>
        <Grid columnGap="none" rowGap="none" enableGutters={false}>
          <Grid.Column span={12}>
            <div className={Styles.CtaBanner__content}>
              <Heading
                as="h2"
                size="4"
                weight="medium"
                textWrap="wrap"
                id={titleId}
                className={Styles.CtaBanner__title}
              >
                {title}
              </Heading>
              <Button
                as="a"
                href={cta.url}
                variant="secondary"
                {...getAnalyticsEvent({
                  action: cta.label,
                  tag: 'a',
                  context: title,
                  location: 'cta-banner',
                })}
              >
                {cta.label}
              </Button>
            </div>
          </Grid.Column>
        </Grid>
      </div>
    </section>
  )
}
